import { useMemo } from "react";
import { useFetchClinicQuery } from "@hooks/queries/clinic/useFetchClinicQuery";
import { useFetchDietitianAccountQuery } from "@hooks/queries/settings/useFetchDietitianAccountQuery";
import { ClinicDto } from "@client/resources/ClinicResource";

export const useClinic = () => {
  const { clinic: clinicData } = useFetchClinicQuery();
  const { account } = useFetchDietitianAccountQuery();

  const mappedClinic = useMemo((): ClinicDto | null => {
    if (!account?.clinic) {
      return null;
    }

    return mapAccountClinicToDto(account.clinic);
  }, [account]);

  const clinicFromApi = clinicData?.clinic ?? null;

  const clinic = useMemo<ClinicDto | undefined>(() => {
    if (clinicFromApi) {
      return mappedClinic
        ? { ...mappedClinic, ...clinicFromApi }
        : clinicFromApi;
    }
    return mappedClinic ?? undefined;
  }, [clinicFromApi, mappedClinic]);

  return {
    clinic,
  };
};

const mapAccountClinicToDto = (
  accountClinic: NonNullable<
    NonNullable<
      ReturnType<typeof useFetchDietitianAccountQuery>["account"]
    >["clinic"]
  >,
): ClinicDto => {
  return {
    id: accountClinic.id,
    name: "",
    email: null,
    logo: null,
    timezone: "",
    owner: { id: 0 },
    createdAt: "",
    isNew: false,
    type: accountClinic.type,
  };
};
